import { API_STATES } from "@/helpers";

const state = {
  showSelectRecipient    : false,
  showNewAnnouncements   : false,
  showNewMessage         : false,
  chatCreateState        : API_STATES.NOT_REQUESTED,
  chatCreateError        : null,
  getStoreEmployeesError : null,
  getStoreEmployeesState : API_STATES.NOT_REQUESTED,
  userStoreEmployees     : [],
  conversations          : {},
  failedMessages         : {},
  conversationsGetState  : API_STATES.NOT_REQUESTED,
  conversationsGetError  : null,
  announcements          : {},
  mappedUsersOnId        : {},
  activeRoomId           : null,
  newMessage             : {
    background : '',
    text       : '',
    avatar     : ''
  },
  newMessageToggle         : true,
  joinChatRoomState        : API_STATES.NOT_REQUESTED,
  joinChatRoomError        : null,
  loadMessagesState        : API_STATES.NOT_REQUESTED,
  loadMessagesError        : null,
  retryFailedMessageState  : API_STATES.NOT_REQUESTED,
  retryFailedMessageError  : null,
  countState               : 0,
  lastMessageReceivedId    : null,
  notificationSettings     : {},
  showRedDot               : false,
  deleteChatHistoryState   : API_STATES.NOT_REQUESTED,
  deleteChatHistoryError   : null,
  getChatRoomMessagesState : {}
}

export default state